'use client';
import { useTranslations } from 'next-intl';
import { lazy, Suspense, useCallback, useState } from 'react';
import type { ElasticVehicle, ElasticVehicleAccessory } from '@//app/api/search/vehicles/[id]';
import { OverflowGrid, OverflowGridItem } from '@//components/OverflowGrid';
import AccessoryItem from './AccessoryItem';

const AccessoryModal = lazy(() => import('./AccessoryModal'));

interface AccessoriesProps {
  vehicle: ElasticVehicle;
  accessories: ElasticVehicleAccessory[] | null;
}

const Accessories = ({ vehicle, accessories }: AccessoriesProps) => {
  const t = useTranslations('pages.item.sellerSection.accessories');
  const [modal, setModal] = useState<ElasticVehicleAccessory | undefined>();
  const onOpenModal = useCallback((accessory: ElasticVehicleAccessory) => setModal(accessory), []);
  const onCloseModal = useCallback(() => setModal(undefined), []);

  if (!accessories || accessories.length === 0) {
    return null;
  }

  return (
    <>
      <Suspense fallback={null}>
        <AccessoryModal accessory={modal} vehicle={vehicle} onCloseModal={onCloseModal} />
      </Suspense>
      <OverflowGrid id="seller-section-accessories" columns={3} heading={t('heading')}>
        {accessories.map((accessory, index) => (
          <OverflowGridItem key={accessory.id}>
            <AccessoryItem
              id={`accessory-card-${index + 1}`}
              accessory={accessory}
              vehicle={vehicle}
              headingLevel={3}
              onOpenModal={onOpenModal}
            />
          </OverflowGridItem>
        ))}
      </OverflowGrid>
    </>
  );
};

export default Accessories;
